// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"627":"bff61742ad7df38b","6707":"1ed4040b390667f4"}[chunkId] + ".css";
};